import httpClient from "./httpClient";

const getCategory = () => httpClient.get("/Category?page=1&pageSize=10000").then(
  (response) => {return response.data.results}
)
const getSubCategory = (id) => httpClient.get(`/Category/GetSubCategory/${id}`).then(
  (response) => {
    return response.data
  }
)

const postCategory = (params) => httpClient.post("/Category",
{
  title: params.title,
  description : params.description,
  image : params.image
  },{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } }
)
const putCategory = (params, id) => httpClient.put(`/Category/${id}`,
  {
    id : id,
    title: params.title,
    description : params.description,
    image : params.image
  },{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } }
)

const deleteCategory = (id) => httpClient.delete(`/Category/${id}`, { headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

export {
  getCategory,
  postCategory,
  putCategory,
  deleteCategory,
  getSubCategory
}
